import React from "react";
import { z } from "zod";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { RichText } from "../../../components/RichText";
import { Media } from "../../../components/Media";
import { BladeContent } from "../../../components/BladeContent";
import { BladeHeader, BladeHeaderTitle } from "../../../components/BladeHeader";
import { CharacterChangesBladeSchema } from "../../../schemas/blades/CharacterChanges";
export const CharacterChangesBladeContractSchema = CharacterChangesBladeSchema.extend({
    type: z.literal("characterChanges"),
});
const _CharacterChanges = ({ title, characters, ...bladeProps }) => {
    return (React.createElement(Blade, { ...bladeProps, "data-testid": "CharacterChanges" },
        React.createElement(BladeContent, { width: "small" },
            title && (React.createElement(BladeHeader, null,
                React.createElement(BladeHeaderTitle, null, title))),
            characters?.map((characterChange) => (React.createElement("div", { "data-testid": `character-changes-${characterChange.character.name}`, key: characterChange.character.name, className: "character-changes-container" },
                React.createElement(Media, { "data-testid": "character-banner", media: characterChange.character.media }),
                React.createElement("div", { className: "character-changes-details" },
                    React.createElement("p", { "data-testid": "character-name", className: "character-name" }, characterChange.character.name),
                    React.createElement(RichText, { "data-testid": "character-changes-summary", className: "character-changes-summary", ...characterChange.summary }),
                    characterChange.changes.map((change, index) => (React.createElement("div", { key: change.title, "data-testid": `character-change-${index}`, className: "character-change" },
                        React.createElement("div", { className: "character-change-header" },
                            change.icon && React.createElement(Media, { "data-testid": "ability-icon", className: "ability-icon", media: change.icon }),
                            React.createElement("p", { "data-testid": "character-ability-title", className: "character-ability-title" }, change.title)),
                        React.createElement("div", { "data-testid": "character-change-body", className: "character-change-body" },
                            React.createElement(RichText, { ...change.description }))))))))))));
};
export const CharacterChanges = styled(_CharacterChanges) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=CharacterChanges.js.map